import { ApiType } from "@gymflow/common";
import { EventOccurrenceDTO } from "@gymflow/types";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { calendarQueryKeys } from "../calendar";
import { eventOccurrenceQueryKeys } from "./eventOccurrenceQueryKeys";
import { eventOccurrenceToUtc } from "./eventOccurrenceToUtc";

// remove any (just "copy-past" from previous variant); We have it because of SideBarOccurrenceForm
export type EventOccurrenceEditVariables = {
  eventId: number;
  patchedFields: Record<string, any>;
  isUpdateAll?: boolean;
  ignoreAvailabilityValidation?: boolean;
};

// remove unknown (eventApi.update) (just "copy-past" from previous variant); We have it because of SideBarOccurrenceForm
export function useEventOccurrenceEdit(
  {
    api,
    tz,
  }: {
    api: ApiType;
    tz: string;
  },
  mutationOpts?: UseMutationOptions<
    EventOccurrenceDTO,
    unknown,
    EventOccurrenceEditVariables
  >,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      eventId,
      patchedFields,
      isUpdateAll,
      ignoreAvailabilityValidation,
    }: EventOccurrenceEditVariables) => {
      return (
        await api.eventApi.update(
          eventId,
          eventOccurrenceToUtc(patchedFields, tz),
          isUpdateAll,
          ignoreAvailabilityValidation,
        )
      ).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: eventOccurrenceQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: calendarQueryKeys.eventOccurrences(),
      });
    },
    ...mutationOpts,
  });
}
